// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.call-search-tab {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: var(--wellsky-sand-tint);
  border-radius: 8px;
  min-height: 600px;
}

.call-search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.call-search-header h2 {
  margin: 0;
  font-size: 24px;
  color: var(--wellsky-indigo);
}

/* Results Container */
.call-search-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background: var(--wellsky-white);
  border-radius: 8px;
  border: 1px solid var(--color-border);
  padding: 20px;
}

.search-error-message {
  padding: 15px;
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  font-size: 14px;
}

.no-results {
  padding: 40px 20px;
  text-align: center;
  color: #6c757d;
  font-size: 16px;
}

/* Results Table */
.call-results-table {
  overflow-x: auto;
}

.call-results-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.call-results-table thead th {
  text-align: left;
  padding: 10px 12px;
  color: var(--wellsky-indigo);
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 2px solid var(--color-border);
  white-space: nowrap;
}

.call-results-table tbody tr.call-row {
  cursor: pointer;
  transition: background 0.15s;
}

.call-results-table tbody tr.call-row:hover {
  background: var(--wellsky-sand-tint);
}

.call-results-table tbody tr.call-row.expanded {
  background: var(--wellsky-sand);
}

.call-results-table td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--color-border);
  vertical-align: middle;
}

.call-timestamp {
  white-space: nowrap;
  font-size: 12px;
  color: var(--wellsky-indigo);
}

.call-person {
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.call-company {
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.call-phone {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 12px;
  white-space: nowrap;
}

.call-disposition {
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Category Badge */
.category-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  color: white;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

/* Answered Badge */
.answered-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

.answered-badge.yes {
  background: #e8f5e9;
  color: #2e7d32;
}

.answered-badge.no {
  background: #ffebee;
  color: #c62828;
}

/* Detail Row */
.detail-row td {
  padding: 0 !important;
  border-bottom: 2px solid var(--wellsky-blue);
}

.detail-loading,
.detail-error {
  padding: 20px;
  text-align: center;
  color: #666;
  font-size: 14px;
}

.detail-error {
  color: #c62828;
}

/* Call Detail Panel */
.call-detail {
  padding: 20px;
  background: var(--wellsky-sand-tint);
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 16px;
}

.detail-section {
  margin-bottom: 12px;
}

.detail-section:last-child {
  margin-bottom: 0;
}

.detail-section h4 {
  margin: 0 0 8px 0;
  font-size: 13px;
  color: var(--wellsky-blue);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-section p {
  margin: 4px 0;
  font-size: 13px;
  color: var(--wellsky-indigo);
  line-height: 1.5;
}

.detail-section strong {
  color: var(--wellsky-indigo);
  font-weight: 600;
}

.guid-text {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 11px;
  color: #666;
}

/* Timing Section */
.timing-section {
  border-top: 1px solid var(--color-border);
  padding-top: 12px;
}

.timing-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.timing-pair {
  display: flex;
  gap: 8px;
  font-size: 13px;
}

.timing-label {
  font-weight: 600;
  color: var(--wellsky-indigo);
  min-width: 130px;
}

.timing-value {
  color: #555;
  font-size: 12px;
}

/* Notes */
.notes-text {
  background: var(--wellsky-white);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 12px;
  font-size: 13px;
  font-family: inherit;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 200px;
  overflow-y: auto;
  margin: 0;
  color: var(--wellsky-indigo);
}

/* Twilio enrichment */
.twilio-section {
  background: rgba(113, 176, 180, 0.08);
  border: 1px solid rgba(113, 176, 180, 0.25);
  border-radius: 6px;
  padding: 12px;
}

/* Responsive */
@media (max-width: 1024px) {
  .call-results-table {
    font-size: 12px;
  }

  .detail-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .detail-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/tabs/CallSearchTab.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;AACf;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".call-search-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  background: var(--wellsky-sand-tint);\n  border-radius: 8px;\n  min-height: 600px;\n}\n\n.call-search-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.call-search-header h2 {\n  margin: 0;\n  font-size: 24px;\n  color: var(--wellsky-indigo);\n}\n\n/* Results Container */\n.call-search-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  background: var(--wellsky-white);\n  border-radius: 8px;\n  border: 1px solid var(--color-border);\n  padding: 20px;\n}\n\n.search-error-message {\n  padding: 15px;\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.no-results {\n  padding: 40px 20px;\n  text-align: center;\n  color: #6c757d;\n  font-size: 16px;\n}\n\n/* Results Table */\n.call-results-table {\n  overflow-x: auto;\n}\n\n.call-results-table table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.call-results-table thead th {\n  text-align: left;\n  padding: 10px 12px;\n  color: var(--wellsky-indigo);\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 2px solid var(--color-border);\n  white-space: nowrap;\n}\n\n.call-results-table tbody tr.call-row {\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.call-results-table tbody tr.call-row:hover {\n  background: var(--wellsky-sand-tint);\n}\n\n.call-results-table tbody tr.call-row.expanded {\n  background: var(--wellsky-sand);\n}\n\n.call-results-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--color-border);\n  vertical-align: middle;\n}\n\n.call-timestamp {\n  white-space: nowrap;\n  font-size: 12px;\n  color: var(--wellsky-indigo);\n}\n\n.call-person {\n  max-width: 140px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.call-company {\n  max-width: 120px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.call-phone {\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.call-disposition {\n  max-width: 140px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Category Badge */\n.category-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 12px;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* Answered Badge */\n.answered-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.answered-badge.yes {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.answered-badge.no {\n  background: #ffebee;\n  color: #c62828;\n}\n\n/* Detail Row */\n.detail-row td {\n  padding: 0 !important;\n  border-bottom: 2px solid var(--wellsky-blue);\n}\n\n.detail-loading,\n.detail-error {\n  padding: 20px;\n  text-align: center;\n  color: #666;\n  font-size: 14px;\n}\n\n.detail-error {\n  color: #c62828;\n}\n\n/* Call Detail Panel */\n.call-detail {\n  padding: 20px;\n  background: var(--wellsky-sand-tint);\n}\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 20px;\n  margin-bottom: 16px;\n}\n\n.detail-section {\n  margin-bottom: 12px;\n}\n\n.detail-section:last-child {\n  margin-bottom: 0;\n}\n\n.detail-section h4 {\n  margin: 0 0 8px 0;\n  font-size: 13px;\n  color: var(--wellsky-blue);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.detail-section p {\n  margin: 4px 0;\n  font-size: 13px;\n  color: var(--wellsky-indigo);\n  line-height: 1.5;\n}\n\n.detail-section strong {\n  color: var(--wellsky-indigo);\n  font-weight: 600;\n}\n\n.guid-text {\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 11px;\n  color: #666;\n}\n\n/* Timing Section */\n.timing-section {\n  border-top: 1px solid var(--color-border);\n  padding-top: 12px;\n}\n\n.timing-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.timing-pair {\n  display: flex;\n  gap: 8px;\n  font-size: 13px;\n}\n\n.timing-label {\n  font-weight: 600;\n  color: var(--wellsky-indigo);\n  min-width: 130px;\n}\n\n.timing-value {\n  color: #555;\n  font-size: 12px;\n}\n\n/* Notes */\n.notes-text {\n  background: var(--wellsky-white);\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  padding: 12px;\n  font-size: 13px;\n  font-family: inherit;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-height: 200px;\n  overflow-y: auto;\n  margin: 0;\n  color: var(--wellsky-indigo);\n}\n\n/* Twilio enrichment */\n.twilio-section {\n  background: rgba(113, 176, 180, 0.08);\n  border: 1px solid rgba(113, 176, 180, 0.25);\n  border-radius: 6px;\n  padding: 12px;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .call-results-table {\n    font-size: 12px;\n  }\n\n  .detail-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .detail-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
